module.exports = __webpack_public_path__ + "img/Path 13 Copy@3x.b99d99f2.png";